import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TransformNumberPiPe } from '@nttp/pipes/transform-number.pipe';
import { TransformCurrencyPiPe } from '@nttp/pipes/transform-currency.pipe';
import { TransformCurrencyMultiplePiPe } from '@nttp/pipes/transform-currency-multiple.pipe';
import { FlagIconPiPe } from '@nttp/pipes/flag-icon.pipe';
import { TransformCountryPiPe } from '@nttp/pipes/transform-country.pipe';
import { FormatBytesPipe } from '@nttp/pipes/format-bytes.pipe';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        TransformNumberPiPe,
        TransformCurrencyPiPe,
        TransformCountryPiPe,
        TransformCurrencyMultiplePiPe,
        FlagIconPiPe,
        FormatBytesPipe
    ],
    exports: [
        TransformNumberPiPe,
        TransformCurrencyPiPe,
        TransformCountryPiPe,
        TransformCurrencyMultiplePiPe,
        FlagIconPiPe,
        FormatBytesPipe
    ]
})
export class PipeModule { }
